<!-- If not canceled -->
<div *ngIf="!document.canceled">
  <!-- If document type has payment -->
  <div *ngIf="documentService.has.payment.indexOf(document.type) !== -1 && document.totalPaid !== 0">
    <!-- If paid in full -->
    <span *ngIf="document.paidInFull; else partiallyPaid"
      class="badge badge-soft-success">{{ 'Paid' | translate }}</span>
    <!-- If paid partially -->
    <ng-template #partiallyPaid>
      <span class="badge badge-soft-warning">{{ 'Partially paid' | translate }}</span>
    </ng-template>
  </div>
  <!-- If no payment and sent by email or post -->
  <span *ngIf="document.totalPaid === 0 && (isSent(document) || document.sentSnailMail)"
    class="badge badge-soft-primary">{{ 'Sent' | translate }}</span>
</div>
<!-- If canceled -->
<span *ngIf="document.canceled" class="badge badge-soft-danger ng-cloak">{{ 'Canceled' | translate }}</span>